import Vue from 'vue';
import App from './App.vue';
import { router } from './router/router';
import Vant from 'vant';
import 'vant/lib/index.css';
import store from './store/index';
import Router from 'vue-router';
import clipboard from 'clipboard';
import ajax from './lib/ajaxdd';
import 'intersection-observer'
import VueLazyComponent from '@xunlei/vue-lazy-component'
import { isShareAppIdShow } from './mixins/isShareAppIdShow'
Vue.mixin(isShareAppIdShow)
Vue.prototype.clipboard = clipboard;
Vue.prototype.$ajax = ajax;
Vue.use(Vant);
Vue.use(VueLazyComponent)
import './icons/index.js' // svg 图标
Vue.config.productionTip = false;
new Vue({
    render: (h) => h(App),
    router,
    store,
    data: {},
    // tslint:disable-next-line:no-empty
    async mounted() {
        //SignalRAspNetCoreHelper.initSignalR(); --具体页面需要signalr时再加载
    },
    // tslint:disable-next-line:no-empty
    created() {
        const originalPush = Router.prototype.push
        Router.prototype.push = function push(location) {
            return originalPush.call(this, location).catch(err => err)
        }
    },
}).$mount('#app');
